import {
  Button as ChakraButton,
  ButtonProps,
  ComponentWithAs,
  forwardRef,
} from '@chakra-ui/react';
import { ComponentProps, useCallback } from 'react';

import { useAnalytics } from 'src/lib/segment';

type ButtonComponent = ComponentWithAs<
  'button',
  ButtonProps & TrackingProperties
>;

type TrackingProperties = {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  trackingId?: string;
  trackingProperties?: object;
};

export const Button = forwardRef<
  ButtonProps & TrackingProperties,
  ButtonComponent
>(
  (
    { trackingId, trackingProperties = {}, onClick = () => {}, ...props },
    ref,
  ) => {
    const { track } = useAnalytics();
    const hoistedOnClick = useCallback(
      (e) => {
        if (trackingId) {
          track(trackingId, trackingProperties);
        }
        onClick(e);
      },
      [track, trackingId, trackingProperties, onClick],
    );

    return <RawButton ref={ref} onClick={hoistedOnClick} {...props} />;
  },
);

export type Props = ComponentProps<typeof ChakraButton>;

const RawButton = forwardRef<Props, typeof ChakraButton>(
  ({ onClick, ...props }, ref) => {
    return <ChakraButton onClick={onClick} {...props} ref={ref} />;
  },
);
